// Based on React's URL sanitization:
// https://github.com/rickhanlonii/react/blob/9f8daa6cb5aae476cf54611874ea7522243c6ba6/packages/react-dom-bindings/src/shared/sanitizeURL.js

// A javascript: URL can contain leading C0 control or \u0020 SPACE, and any newline or tab are filtered out as if they're not part of the URL.
const isJavaScriptProtocol =
  // eslint-disable-next-line no-control-regex, no-useless-escape
  /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i

export function sanitizeURL(url, { allowExternal = true } = {}) {
  const trimmedUrl = ("" + url).trim()

  // Block javascript: URLs first (most dangerous)
  if (isJavaScriptProtocol.test(trimmedUrl)) {
    return "javascript:throw new Error('Blocked a javascript: URL as a security precaution.')"
  }

  // Block URLs with null bytes which can bypass origin checks
  if (trimmedUrl.includes("\0") || trimmedUrl.includes("%00")) {
    return "javascript:throw new Error('Blocked a URL with null byte as a security precaution.')"
  }

  // Try to parse the URL
  try {
    const parsedUrl = new URL(trimmedUrl, window.location.origin)

    // Only allow http and https protocols
    if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
      return "javascript:throw new Error('Blocked a non-HTTP(S) URL as a security precaution.')"
    }

    // Check if external URLs are allowed
    if (!allowExternal) {
      // Simply check if origins match - this handles all external URL cases
      if (parsedUrl.origin !== window.location.origin) {
        return "javascript:throw new Error('Blocked an external URL as a security precaution.')"
      }
    }
  } catch (e) {
    // Invalid URL - could be a relative path, fragment, or query string
    // Check if it starts with a dangerous protocol
    const protocolMatch = trimmedUrl.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/)
    if (protocolMatch) {
      const protocol = protocolMatch[1].toLowerCase()
      // Block any explicit protocol that isn't http or https
      if (protocol !== "http" && protocol !== "https") {
        return "javascript:throw new Error('Blocked a non-HTTP(S) URL as a security precaution.')"
      }
      // If it has http/https protocol but failed to parse, it might still be external
      // when allowExternal is false, we should be extra cautious
      if (!allowExternal) {
        return "javascript:throw new Error('Blocked an external URL as a security precaution.')"
      }
    }
    // Otherwise allow - it's likely a relative path
  }

  return trimmedUrl
}
